<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="接收人">
                <a-input v-model="query.receiveName" placeholder="请输入接收人" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="发送状态">
                <a-select placeholder="请选择发送状态" v-model="query.status" allow-clear>
                  <a-select-option :value="1">发送成功 </a-select-option>
                  <a-select-option :value="2">发送失败 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="发送时间">
                <a-date-picker style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  :showTime="false"
                  placeholder="选择日期"
                  :allowClear="false"
                  v-model="query.startTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="事件名称">
                <a-input v-model="query.eventName" placeholder="请输入事件名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="事件编号">
                <a-input v-model="query.eventNo" placeholder="请输入事件编号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="exportHandle()" :loading="exportLoading"
                v-action:export>导出</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :pagination="pagination"
        @change="pageChange"
        bordered
      >
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record.id, 1)" style="margin-right: 10px" v-action:Resend>重新发送</a>
          <a @click="Handle(record.id, 2)">详情</a>
        </span>
        <span slot="status" slot-scope="text">
          <span v-if="text == 1">发送成功</span>
          <span v-if="text == 2">发送失败</span>
        </span>
      </a-table>
      <a-modal
        :title="title"
        width="50%"
        v-model="addOrUpdateVisible"
        :destroyOnClose="true"
        @ok="addOrUpdateVisible = false"
      >
        <template #footer v-if="this.Resendshwo == true">
          <a-button type="primary" @click="ResendOk">重新发送</a-button>
          <a-button type="primary" @click="ResendCancel">取消</a-button>
        </template>
        <a-row class="Details-row" type="flex" justify="center" :gutter="4">
          <a-col :md="12" :sm="24"> 事件编号：{{ particular.eventNo }}</a-col>
          <a-col :md="12" :sm="24">事件名称：{{ particular.eventName }} </a-col>
          <a-col :md="12" :sm="24"> 接收人：{{ particular.receiveName }}</a-col>
          <a-col :md="12" :sm="24">接收人类型：{{ particular.receiveType }} </a-col>
          <a-col :md="12" :sm="24"> 用户编号：{{ particular.msgCode }}</a-col>
          <a-col :md="12" :sm="24">接收号码：{{ particular.phone }} </a-col>
          <a-col :md="12" :sm="24"> 发送时间：{{ particular.createTime }}</a-col>
          <a-col :md="12" :sm="24"
            >发送状态:
            <span v-if="particular.status == 1">发送成功</span>
            <span v-if="particular.status == 2">发送失败</span></a-col
          >
          <a-col :md="24" :sm="24" v-if="this.Resendshwo == false" style="margin-top: 10px">
            短信内容：{{ particular.smsParam }}
          </a-col>
          <a-col :md="24" :sm="24" v-if="this.Resendshwo == true">
            <a-form-model
              class="log-form"
              :model="repeatDTO"
              ref="repeatDTO"
              :rules="rules"
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 14 }"
            >
              <a-form-model-item label="短信内容" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" prop="content">
                <a-textarea placeholder="多行输入" v-model="repeatDTO.content" :rows="4" />
              </a-form-model-item>
            </a-form-model>
          </a-col>
        </a-row>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      title: '重新发送',
      isUpdate: false,
      disabled: false,
      Resendshwo: true,
      repeatDTO: {
        content: '',
        id: '',
      },
      equipmentList: [],
      parameterList: [],
      queryUrl: '/pipe-network/api/v1/sms/page',
      modifyUrl: '/pipe-network/alarm_pmt_configs',
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/api/v1/sms/', // 删除数据url
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/api/v1/sms/',
      exportDataUrl: 'pipe-network/api/v1/sms/export', //导出
      exportFileName: '消息发送记录.xlsx',
      visible: false,
      confirmLoading: false,
      zoneTreeData: [], // 分区数据选项
      particular: {},
      query: {
        receiveName: '',
        status: '',
        startTime: '',
        eventName: '',
        eventNo: '',
      },
      columns: [
        {
          title: '事件编号',
          dataIndex: 'eventNo',
        },
        {
          title: '事件名称',
          dataIndex: 'eventName',
        },
        {
          title: '接收人',
          dataIndex: 'receiveName',
          scopedSlots: { customRender: '' },
        },
        {
          title: '接收人类型',
          dataIndex: 'receiveType',
        },
        {
          title: '发送状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '发送时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  computed: {
    rules() {
      return {
        content: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
      }
    },
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.queryList()
  },
  methods: {
    Handle(id, i) {
      if (i == 1) {
        this.Resendshwo = true
        this.title = '重新发送'
      } else {
        this.Resendshwo = false
        this.title = '详情'
      }
      this.currentId = id
      this.repeatDTO.id = id
      this.$http.get(`/pipe-network/api/v1/sms/${this.currentId}`).then((res) => {
        if (res.code == 0) {
          this.particular = res.data
          this.repeatDTO.content = res.data.smsParam
          this.addOrUpdateVisible = true
        }
      })
    },
    ResendOk() {
      this.$refs.repeatDTO.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/api/v1/sms/repeat', { ...this.repeatDTO })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.$refs.repeatDTO.resetFields()
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    ResendCancel() {
      this.$refs.repeatDTO.resetFields()
      this.addOrUpdateVisible = false
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
/deep/.Details-row > .ant-col-md-12 {
  display: block;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  margin-top: 20px;
}
.log-form {
  margin-top: 20px;
}
</style>
